import { createContext } from "react";

export const ActionPopupContext = createContext();
